import React from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Grid,
  Chip,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const topics = [
  { id: "probability-and-p&c", name: "probability-and-p&c" },
  { id: "multiplications", name: "Multiplications" },
  { id: "squaring", name: "Squaring" },
  { id: "squareroot", name: "Squareroot" },
  { id: "percentage", name: "Percentage" },
  { id: "pass-fail", name: "Pass-fail" },
  { id: "consumption", name: "Consumption" },
  { id: "simple-intrest", name: "Simple-intrest" },
  { id: "compound-intrest", name: "Compound-intrest" },
  
  { id: "ratio", name: "Ratio" },
  { id: "profit-and-loss", name: "Profit-and-loss" },
  { id: "discount", name: "Discount" },
  { id: "average", name: "Average" },
  { id: "cyclicity", name: "Cyclicity" },
  { id: "number-series", name: "Number-series" },
  { id: "letter-series", name: "Letter-series" },
  { id: "coding-decoding", name: "Coding-decoding" },
  { id: "directions", name: "Directions" },
  { id: "syllogism", name: "Syllogism" },
  { id: "calendar", name: "Calendar" },
  { id: "cubes-and-dice", name: "Cubes-and-dice" },
  { id: "games-and-tournament", name: "Games-and-tournament" },
  { id: "sql", name: "sql" },


];

const TopicPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        p: { xs: 2, md: 5 },
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      {/* Back Button */}
      <Button
        onClick={() => navigate(-1)}
        startIcon={<ArrowBackIosNewIcon />}
        sx={{
          mb: 3,
          backgroundColor: "#fff",
          color: "#333",
          border: "1px solid #ddd",
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 600,
          px: 2.5,
          py: 1,
          boxShadow: 1,
          "&:hover": {
            backgroundColor: "#f0f0f0",
            boxShadow: 2,
          },
        }}
      >
        Back
      </Button>

      <Typography
        variant="h5"
        fontWeight={700}
        textAlign="center"
        gutterBottom
        sx={{ color: "#333" }}
      >
        Explore Aptitude Topics
      </Typography>

      <Typography
        variant="subtitle1"
        textAlign="center"
        mb={6}
        color="text.secondary"
      >
        Choose a topic to start practicing.
      </Typography>

      <Grid container spacing={3}>
        {topics.map((topic) => (
          <Grid item xs={12} sm={6} md={4} key={topic.id}>
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: 2,
                "&:hover": {
                  boxShadow: 5,
                  transform: "translateY(-4px)",
                },
                transition: "all 0.3s",
              }}
            >
              <CardActionArea
                onClick={() => navigate(`/ppractice/${topic.id}`)}
              >
                <CardContent
                  sx={{
                    textAlign: "center",
                    py: 2,
                    backgroundColor: "#fff",
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight={600}
                    color="text.primary"
                  >
                    {topic.name}
                  </Typography>
                  <Chip
                    label="Start Practice"
                    size="small"
                    sx={{
                      mt: 1.5,
                      backgroundColor: "white",
                      color: "#333",
                      fontWeight: 600,
                    }}
                  />
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TopicPage;
